<template>
  <div>
    <transition>
    <section v-show="!navVisible">
      <div class="anim-wrapper full-height">
        <div v-show="!navVisible">
          <hero :hero-props="{ height: 80, onComplete: displayNav }"></hero>
        </div>
      </div>
    </section>
    </transition>
    <transition name="fade" enter-active-class="animated fadeIn">
      <div v-if="navVisible">
        <div class="bg-color-black pb-5">
          <section id="home" class="container margin-for-nav">
            <div class="row">
              <div class="col-12 offset-md-3 col-md-6">
                <row-section-header class="my-3">
                  <span slot="title">
                    Design Portfolio
                  </span>
                </row-section-header>
              </div>
            </div>
            <div class="row pb-md-4">
              <div class="col-12 col-sm-4 mb-5 pb-5" v-if="section.visible" v-for="(section, index) in getSections()">
                <a class="link" v-scroll-to="scrollToDest(section)">
                  <card :contents="section" class="no-text title-serif title-overlay"></card>
                </a>
              </div>
            </div>
          </section>
        </div>
        <page :category="category">
          <affixed-section slot="page" slot-scope="pageProps" :section="pageProps.section" :index="pageProps.index" v-if="pageProps.section.visible">
            <component :is="sectProps.component" slot-scope="sectProps" :section="sectProps.section" :side="sectProps.side"></component>
          </affixed-section>
        </page>
      </div>
    </transition>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import { mapActions, mapGetters } from 'vuex'
import Card from '@/components/Card.vue'
import AffixedSection from '@/components/AffixedSection.vue'
import Hero from '@/components/Hero.vue'
import Projects from '@/components/sections/main/Projects.vue'
import About from '@/components/sections/main/About.vue'
import Contact from '@/components/sections/main/Contact.vue'
import RowVerticalCenter from '@/components/rows/VerticalCenter.vue'
import RowSectionHeader from '@/components/rows/SectionHeader.vue'

export default {
  name: 'main-page',
  components: {
    Page,
    AffixedSection,
    Hero,
    Card,
    Projects,
    About,
    Contact,
    RowVerticalCenter,
    RowSectionHeader,
  },
  computed: {
    ...mapGetters(['sections', 'navVisible'])
  },
  data: function () {
    return {
      category: 'Main',
    }
  },
  methods: {
    getSections: function (opts) {
      // Duplicated, original is in  Page.vue
      return this.sections.filter(function(section) {
        return section.category == this.category
      }.bind(this))
    },
    scrollToDest: function (section) {
      return {
        el: "#" + section.id,
      }
    },
    displayNav: function (evt) {
      this.showNav()
    },
    ...mapActions(['showNav'])
  },
}
</script>

<style lang="scss">
.link {
  cursor: pointer;
}
.anim-wrapper {
  background-color: black;
  position: relative;
  .hero {
    position: absolute;
    top: 50%;
    margin-top: -40px;
    left: 0;
    right: 0;
  }
}
#home {
  h4 {
    font-size: 2.5rem;
  }
  h5 {
    font-size: 1.5rem;
    font-weight: bold;
  }
}
.title-overlay .card-body {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Main.vue